<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="load">
                    <b-col lg="3" sm="12" class="text-left">
                        <lg-form-input invalidFeedback="O número produto deve ser informado!" description=""
                            v-model="form.numero" label="Número:" />
                    </b-col>

                    <b-col lg="7" sm="12" class="text-left">
                        <lg-form-input invalidFeedback="A justificativa deve ser informado!" description=""
                            v-model="form.descricao" label="Descrição:" />
                    </b-col>

                    <b-col cols="2" class="text-right">
                        <b-form-checkbox v-model="descricaoExata" id="checkbox-3" class="mt-3 mr-5" @change="load">
                            <template #default>
                                <p style="font-size: 12px;">Descrição Exata</p>
                            </template>
                        </b-form-checkbox>
                    </b-col>


                    <b-col lg="4" sm="4" class="text-left">
                        <lg-finder-page-tipo-medida :prefix="prefix + title + ' > '" id="finderTipoMedida"
                            @input="selectTipoMedida"></lg-finder-page-tipo-medida>
                    </b-col>

                    <b-col lg="2" sm="12" class="text-left">
                        <lg-form-const-select :disabled="!podeMudarSituacao" @change="load" label="Situação:"
                            v-model="form.situacao" :options="form.optionsFilterSituacao" />
                    </b-col>


                    <b-col lg="3" sm="12" class="text-left">
                        <lg-form-const-select label="Tipo Produto:" :disabled="!podeMudarTipo" @change="load"
                            v-model="form.tipoProduto" :options="form.optionsFilterGrupoProduto" />
                    </b-col>


                    <b-col lg="3" sm="12" class="text-left">
                        <lg-form-const-select :disabled="grupoProduto != null || !podeMudarTipo" label="Grupo Produto:"
                            @change="load" v-model="form.grupoProduto" :options="form.optionsFilterProduto" />
                    </b-col>
                </b-form-row>

                <b-form-row>
                    <b-col cols="12" class="text-right">
                        <b-button id="limparProduto" class="my-2" size="sm" style="height: 20px" pill variant="primary"
                            @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limparProduto" title="Limpar"></b-tooltip>
                        </b-button>

                        <b-button id="localizaProdutor" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizaProdutor" title="Localizar"></b-tooltip>
                        </b-button>

                        <b-button id="novoProduto" class="mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="showCadastroModal" v-if="temPrivilegioInclusao()">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" /> &nbsp;
                            </div>
                            <b-tooltip target="novoProduto" title="Adicionar novo..."></b-tooltip>

                        </b-button>
                    </b-col>
                </b-form-row>
            </b-card>

            <b-card bg-variant="light">
                <b-table responsive small :busy="this.busy" :items="this.records" :fields="this.tableFields"
                    :hover="true" @row-dblclicked="produtoSelect" show-empty>
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(situacao)="row">
                        <div :id="row.index + 'switchGrupoProdutoList'">

                            <b-form-checkbox v-b-tooltip.hover.top="'Ativar/Desativar...'"
                                :disabled="!temPrivilegioEdicao()" v-model="row.item.situacao"
                                @change="alteraSituacao(row.item)" name="check-button" switch size="lg" :value="1"
                                :unchecked-value="0" />
                        </div>

                    </template>

                    <template v-slot:cell(action)="row">


                        <b-button :disabled="!temPrivilegioEdicao()" :id="row.index + 'edit-button-produto'"
                            class="my-2" size="sm" pill variant="primary" @click="showCadastroModal(row.item)">
                            <b-icon v-b-tooltip.hover.top="'Editar'" icon="pencil-square" />
                        </b-button>
                    </template>

                    <template v-slot:cell(foto)="row">

                        <b-button :disabled="!temPrivilegioAcessarFoto()" :id="row.index + 'edit-button-foto'"
                            class="my-2" size="sm" pill variant="primary" @click="visualizar(row.item)">
                            <b-icon v-b-tooltip.hover.top="'Foto do Produto'" icon="card-image" />
                        </b-button>

                    </template>

                    <template v-slot:cell(especificacao)="row">

                        <b-button :disabled="!temPrivilegioAcessarFoto()" :id="row.index + 'edit-button-especificacao'"
                            class="my-2" size="sm" pill variant="primary" @click="abrirEspecificacao(row.item)">
                            <b-icon v-b-tooltip.hover.top="'Especificação do Produto'" icon="clipboard" />
                        </b-button>

                    </template>

                    <template v-slot:cell(cota)="row">

                        <b-button v-if="row.item.tipoBem && row.item.tipoBem.id == TipoProdutoEnum.CONSUMO.cod"
                            :id="row.index + 'edit-button-especificacao'" class="my-2" size="sm" pill variant="primary"
                            @click="abrirCota(row.item)">
                            <b-icon v-b-tooltip.hover.top="'Configuração Cota'" icon="gear-wide-connected" />
                        </b-button>


                    </template>



                </b-table>

                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <Modal-foto-produto-almoxarifado v-if="showModalFotoProdutoAlmoxarifado" @close="fecharModalFoto"
            :prefix="prefix + title" :id="id" />

        <ProdutoForm :prefix="prefix + title + ' > '" v-if="showCadastro" :id="id" @close="fecharModal"></ProdutoForm>

        <ProdutoCotaDepartamento v-if="showCota" @close="fecharCota" :prefix="prefix + title + ' > '"
            :produto="produto" />

        <LgFinderPageEspecificacaoProduto v-if="showEspecificacao" :produto="produto" :isModal="true"
            id="finderLgFinderPageEspecificacaoProdutoProdutoList" label="Especificação:"
            :prefix="prefix + title + ' > '" @input="handleEspecificacao" />

    </b-card>
</template>
<script>
import LgFinderPageTipoMedida from "@/components/Finders/LgFinderPageTipoMedida.vue"
import AtaService from "@/core/api/AtaService"
import ResourceService from "@/core/api/ResourceService"
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ModalFotoProdutoAlmoxarifado from "@/core/components/Modals/ModalFotoProdutoAlmoxarifado.vue"
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import ProdutoForm from "./ProdutoForm.vue"
import TipoProdutoEnum from "@/core/utils/TipoProdutoEnum"
import ProdutoCotaDepartamento from "./ProdutoCotaDepartamento.vue"
import LgFinderPageEspecificacaoProduto from "@/components/Finders/LgFinderPageEspecificacaoProduto.vue"

export default {
    name: "ProdutoList",

    components: {
        ProdutoCotaDepartamento,
        LgFormInput,
        LgFormConstSelect,
        LgFinderPageTipoMedida,
        ProdutoForm,
        ModalFotoProdutoAlmoxarifado,
        LgFinderPageEspecificacaoProduto
    },

    props: {
        isAbertoFromModal: {
            type: Boolean,
            default: false
        },

        podeMudarSituacao: {
            type: Boolean,
            default: true,
        },
        podeMudarTipo: {
            type: Boolean,
            default: true,
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Produto",
        },
        idAta: {
            type: Number,
            default: null,
        },
        grupoProduto: {
            type: Number,
            default: null,
        }
    },

    data() {
        return {
            descricaoExata: false,
            showEspecificacao: false,
            produto: null,
            showCota: false,
            TipoProdutoEnum: TipoProdutoEnum,
            id: null,
            showModalFotoProdutoAlmoxarifado: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: {},
            showCadastro: false,

            form: {
                numero: "",
                descricao: "",
                tipoMedida: {},
                tipoBem: "",
                tipoProduto: null,
                grupoProduto: this.grupoProduto ? this.grupoProduto : null,
                optionsFilterProduto: [
                    { key: "filtertipoProduto", text: "Todos", value: null },
                    { key: "filtertipoProduto", text: "Material de Consumo", value: 4 },
                    { key: "filtertipoProduto", text: "Material Permanente", value: 5 },
                    { key: "filtertipoProduto", text: "Serviço", value: 6 },
                ],
                optionsFilterGrupoProduto: [
                    { key: "filterGrupoProduto", text: "Todos", value: null },
                    { key: "filterGrupoProduto", text: "Produto", value: 1 },
                    { key: "filterGrupoProduto", text: "Serviço", value: 2 },
                ],

                situacao: 1,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: null },
                    { key: "filterSituacao", text: "Ativo", value: 1 },
                    { key: "filterSituacao", text: "Inativo", value: 0 },
                ],
            },
        }
    },

    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/produto`)
        this.$tiposServiceProduto = new ResourceService(`/api/grupos-produto`)
    },

    mounted() {
        this.load()
    },

    watch: {
        page() {
            this.load()
        },
    },

    computed: {
        tableFields() {
            return [
                {
                    key: "numero",
                    label: "Número",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "py-1",
                    thClass: "text-left",
                },
                {
                    key: "descricaoResumida",
                    label: "Descrição",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "py-1",
                },
                {
                    key: "tipoMedida.descricao",
                    label: "Tipo de medida",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "py-1",
                },
                {
                    key: "prioridade.nome",
                    label: "Prioridade",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "py-1",
                },
                {
                    key: "tipoProduto.descricao",
                    label: "Tipo Produto",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "py-1",
                },

                {
                    key: "classe.subgrupoProduto.grupoProduto.descricao",
                    label: "Grupo",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "py-1",
                },
                {
                    key: "classe.subgrupoProduto.descricao",
                    label: "Subgrupo",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "py-1",
                },
                {
                    key: "classe.descricao",
                    label: "Classe",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "py-1",
                },
                {
                    key: "foto",
                    label: " ",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "especificacao",
                    label: " ",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "cota",
                    label: " ",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "situacao",
                    label: " ",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "action",
                    label: " ",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
            ]
        },
    },

    methods: {
        handleEspecificacao() {
            this.showEspecificacao = false;
            this.produto = null;

        },
        abrirEspecificacao(item) {
            this.produto = item;
            this.showEspecificacao = true;
        },
        fecharCota() {
            this.showCota = false;
            this.produto = null;
        },

        abrirCota(item) {
            this.produto = item;

            this.showCota = true;
        },
        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ALMOXARIFADO_EDITAR)

        },
        temPrivilegioInclusao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ALMOXARIFADO_INCLUIR)

        },

        temPrivilegioAcessarFoto() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ACESSAR_FOTO_PRODUTO)

        },
        temPrivilegioCotaDepartamento() {
            return verificaPrivilegio(PrivilegiosEnum.CONFIGURACAO_COTA_DEPARTAMENTO_ACESSAR)

        },
        temPrivilegio() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_ALMOXARIFADO_EDITAR)

        },

        visualizar(item) {
            this.id = item.id
            this.showModalFotoProdutoAlmoxarifado = true
        },
        fecharModalFoto() {
            this.id = null;
            this.showModalFotoProdutoAlmoxarifado = false;
        },
        fecharModal() {
            this.id = null
            this.showCadastro = false
            this.load()
        },
        showCadastroModal(item) {
            if (item)
                this.id = item.id
            this.showCadastro = true
        },
        selectTipoMedida(item) {
            this.form.tipoMedida = item
            this.load()
        },
        async load() {
            if (this.idAta) {
                this.busy = true
                await AtaService.getProdutosByAtaIdPaged(this.idAta, {
                    size: this.perPage,
                    page: this.page - 1,
                }).then((response) => {
                    this.records = response.data.content.map(item => item.produto)
                })
                this.busy = false
                return
            }
            this.filtro = {}
            this.filtro.descricaoExata = this.descricaoExata;

            if (this.form.tipoMedida && this.form.tipoMedida.id) {
                this.filtro.tipoMedida = this.form.tipoMedida.id
            }

            if (this.form.situacao != null) {
                this.filtro.situacao = this.form.situacao
            }

            if (this.form.numero && this.form.numero != "") {
                this.filtro.numero = this.form.numero
            }

            if (this.form.descricao && this.form.descricao != "") {
                this.filtro.descricao = this.form.descricao
            }

            if (this.form.grupoProduto != null) {
                this.filtro.grupoProduto = this.form.grupoProduto
            }

            if (this.form.tipoProduto != null)
                this.filtro.tipoProduto = this.form.tipoProduto


            this.busy = true
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            })
        },

        clearForm() {
            this.form.numero = ""
            this.form.descricao = ""
            this.form.tipoMedida = {}
            this.form.tipoProduto = 1
            this.form.grupoProduto = 4
            this.form.situacao = 1
            this.descricaoExata = false;

            this.load()
        },

        async produtoSelect(item) {
            if (this.isAbertoFromModal) {
                this.busy = true;
                this.$emit("onDblClickProduto", item)
            } else {
                this.showCadastroModal(item);
            }
        },

        async tiposProdutoList({ filter, page = 1 }) {
            return this.$tiposProdutoService.findAll({ filter, page, limit: 5 })
        },

        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Produto?",
                item.descricaoResumida.toUpperCase()
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao === 1 ? 0 : 1
            }
        },


        async confirmarAlteracaoSituacao(item) {
            const { status } = await this.$service.alteraSituacao(item)
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                })
            }
        },

    },
}
</script>
